export default __webpack_public_path__ + "static/media/logo03.cb89f940.svg";